export enum BookTimeNowThemeEnum {
  DEFAULT = 'default',
  SEARCH_CONTENT_PAGE = 'search-content-page',
}
